import {Directive, Input} from '@angular/core';

@Directive()
export abstract class AbstractStyleComponent {
  key: string | null = null;
  @Input() label: string | null = null;
  private onValueChangeCallback: ((key: string, value: any) => void) | null = null;

  abstract setValue(value: any): void;

  abstract getValue(): any;

  onValueChange(callbackfn: (key: string, value: any) => void): void {
    this.onValueChangeCallback = callbackfn;
  }

  onChange(): void {
    if (this.onValueChangeCallback && this.key) {
      this.onValueChangeCallback(this.key, this.getValue());
    }
  }

  parseNumberValue(value: any, defaultValue: number | null = null): number | null {
    const v = parseInt(value);

    return isNaN(v) ? defaultValue : v;
  }

  formatPixelNonZeroValue(value: any): string | null {
    const v = parseInt(value);

    if (!isNaN(v) && v > 0) {
      return v.toString() + 'px';
    }

    return null;
  }

  formatPixelValue(value: any): string | null {
    const v = parseInt(value);

    if (!isNaN(v) && v >= 0) {
      return v.toString() + 'px';
    }

    return null;
  }

  isValidColor(value: string | null): boolean {
    return /^#[0-9a-fA-F]{6,8}$/.test(value ?? '');
  }
}
